import { gql } from "apollo-boost";

export const CREATE_DAMAGED_PRODUCT = gql`
mutation CreateDamagedProduct($data: DamagedProductInput) {
  createDamagedProduct(data: $data) {
    id
    stock {
      id
    }
    shop {
      id
      name
    }
    damageType
    damageReason
    damageDate
    damagedAmount
    name
    images
    createdAt
    updatedAt
    isDeleted
  }
}`

export const UPDATE_DAMAGED_PRODUCT = gql`
mutation UpdateDamagedProduct($where: DamagedProductWhereInputOne, $data: DamagedProductInput) {
  updateDamagedProduct(where: $where, data: $data) {
    id
    stock {
      id
    }
    shop {
      id
      name
    }
    damageType
    damageReason
    damageDate
    damagedAmount
    name
    images
    createdAt
    updatedAt
    isDeleted
  }
}`

export const DELETE_DAMAGED_PRODUCT = gql`
mutation DeleteDamagedProduct($where: DamagedProductWhereInputOne) {
  deleteDamagedProduct(where: $where) {
    id
    stock {
      id
    }
    shop {
      id
      name
    }
    damageType
    damageReason
    damageDate
    damagedAmount
    name
    images
    createdAt
    updatedAt
    isDeleted
  }
}`